<script>
export default {
  name: 'DouSearch',
  props: {
    loading: Boolean,
    label: String,
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['input', 'select', 'input-search'],
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    computedValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    select (v) {
      this.$emit('input', v.vendor_code + ' ' + v.name)
      this.$emit('select', v)
      this.isActive = false
    },
    handleClickOutside (event) {
      const ref = this.$refs.dropdownRef

      if (ref && !ref.contains(event.target)) {
        this.isActive = false
      }
    },
    clear () {
      this.$emit('input', null)
      this.$emit('select', null)
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  unmounted () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<template>
  <div class="relative dou-search" ref="dropdownRef">
    <div class="p-1 text-xs text-gray-600">{{ label }}</div>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <input
          @click="isActive = true"
          v-model="computedValue"
          class="w-full rounded-lg border border-gray-200 focus:shadow p-2 outline-none focus:border-green-500 focus:rounded-b-none"
          type="text"
          :placeholder="label"
          @input="e => $emit('input-search',  e.target.value)"
      />
      <button
          @click="clear()"
          style="position: absolute; right: 5px; border: none; border-radius: 100%; background: none"
      >
        <img src="/images/close_ico.svg" alt="">
      </button>
    </div>
    <div v-if="loading && isActive" class="preloader" :class="{'active': loading}">
      <div class="loading-bar"></div>
    </div>
    <div
        v-if="isActive && items.length > 0"
        class="result-list"
    >
      <ul>
        <li
            @click="select(item)"
            v-for="(item, index) in items"
            :key="index"
        >
          {{ item.vendor_code }} {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">

.preloader {
  position: absolute;
  margin-top: -1px;
  width: 100%;
  height: 2px; /* Тонкая линия */
  z-index: 9999;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.loading-bar {
  width: 100%;
  height: 100%;
  background: linear-gradient(
          to right,
          transparent 0%,
          #00a6ff 20%, /* Фиолетовый (Apple Intelligence) */
          #ff6f31 40%,
          #bbdefb 60%,
          #0288d1 80%, /* Синий */
          transparent 100%
  );
  animation: slide 1.5s infinite linear;
  opacity: 0.9;
}

/* Анимация движения градиента */
@keyframes slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.preloader.active {
  opacity: 1;
}

.relative {
  position: relative;
}

.dou-search {
  input {
    margin: 0;
  }
  .result-list {
    position: absolute;
    width: 100%;
    background: white;
    box-shadow: 5px 5px 10px #ccc;
    margin-bottom: 100px;
    ul {
      max-height: 200px;
      overflow-y: auto;
      li {
        padding: 12px;
        cursor: pointer;
        background: white;
        &:hover {
          background: #ffe6d5;
        }
      }
    }
  }
}

</style>
